import { createApi } from "@reduxjs/toolkit/query/react";

import { endpoints } from "consts";
import {
  UploadMediaRequestDto,
  UploadMediaResponseDto,
} from "types/uploadMedia";

import { coreQuery } from "utils/baseQuery";

export const uploadMediaAPI = createApi({
  reducerPath: "uploadMediaAPI",
  baseQuery: coreQuery(),
  tagTypes: ["uploadMedia"],
  endpoints: build => ({
    uploadMediaData: build.mutation<
      UploadMediaResponseDto,
      UploadMediaRequestDto
    >({
      query: ({ data }) => ({
        url: `${endpoints.upload}/presigned-url`,
        method: "POST",
        data,
      }),
    }),
  }),
});

export const { useUploadMediaDataMutation } = uploadMediaAPI;
